import { EyeIcon } from "@images/svgIcons/eyeIcon"
import { InformationAlertIcon } from "@images/svgIcons/informationAlertIcon"
import { BoxOfferFormPageProps } from "@modules/boxOffer/components/boxOfferForm"
import { BoxOfferFormSection } from "@modules/boxOffer/components/boxOfferFormSection"
import { word } from "@modules/core/utils/i18n"
import { FormikInput } from "@modules/ui/components/formikInput"
import { HUButton } from "@modules/ui/components/huButton"
import { HUCardAlert } from "@modules/ui/components/huCardAlert"
import { HUText } from "@modules/ui/components/huText"
import { useEffect } from "react"
import { useTheme } from "styled-components"

export const BoxOfferFormThirdPage = ({
  formik,
  isFormFieldInValid,
  getFormErrorMessage,
  handleSubmit,
  setPageNumber,
  isArchiveEdition,
}: BoxOfferFormPageProps) => {
  const theme = useTheme()

  useEffect(() => {
    if (isArchiveEdition) {
      formik.setFieldValue("showcaseDisplay", false)
    }
  }, [isArchiveEdition])

  useEffect(() => {
    if (!formik.values.showcaseDisplay) {
      formik.setFieldValue("priceDisplay", false)
    }
  }, [formik.values.showcaseDisplay])

  return (
    <div className="flex flex-column gap-6 pb-4">
      <div className="flex flex-column gap-2">
        <HUText fontStyle="TL">{`${word(`offer.form.${formik.values.type}.create`)} (3/3)`}</HUText>
        <HUText fontStyle="BM" color={theme.neutralColor700}>
          {word(`offer.form.${formik.values.type}.subtitle`)}
        </HUText>
      </div>
      {isArchiveEdition && (
        <HUCardAlert
          style={{ padding: "8px 24px 8px 24px" }}
          title={""}
          description={word("box.offer.form.infos.archivedEdition.information.description")}
          icon={<InformationAlertIcon backgroundColor={""} color={theme.mainWhite} />}
        />
      )}
      <div className="gap-2">
        <BoxOfferFormSection
          title={word("box.offer.form.infos.visibility.title")}
          icon={<EyeIcon color={theme.mainWhite} />}
          description={word("box.offer.form.infos.visibility.subtitle")}
          className={"mb-5"}
        />
        <div>
          <FormikInput
            type="switchInline"
            label={word("box.offer.form.infos.showcaseDisplay.label")}
            textSwitch={word("box.offer.form.infos.showcaseDisplay.textSwitch")}
            description={word("box.offer.form.infos.showcaseDisplay.description")}
            name="showcaseDisplay"
            getFieldProps={formik.getFieldProps}
            isInvalid={isFormFieldInValid("showcaseDisplay")}
            error={getFormErrorMessage("showcaseDisplay")}
            setFieldValue={formik.setFieldValue}
            switchProps={{
              checked: formik.values.showcaseDisplay,
            }}
            disabled={isArchiveEdition}
          />
        </div>
        <div>
          <FormikInput
            type="switchInline"
            label={word("box.offer.form.infos.priceDisplay.label")}
            textSwitch={word("box.offer.form.infos.priceDisplay.textSwitch")}
            description={word("box.offer.form.infos.priceDisplay.description")}
            name="priceDisplay"
            getFieldProps={formik.getFieldProps}
            isInvalid={isFormFieldInValid("priceDisplay")}
            error={getFormErrorMessage("priceDisplay")}
            setFieldValue={formik.setFieldValue}
            disabled={!formik.values.showcaseDisplay}
            switchProps={{
              checked: formik.values.priceDisplay,
            }}
          />
        </div>
        <div>
          <FormikInput
            type="autonomousPurchase"
            label={word("box.offer.form.infos.autonomousPurchase.label")}
            isRequiredInput
            name="autonomousPurchase"
            getFieldProps={formik.getFieldProps}
            isInvalid={isFormFieldInValid("autonomousPurchase")}
            error={getFormErrorMessage("autonomousPurchase")}
            setFieldValue={formik.setFieldValue}
            autonomousPurchaseProps={{
              isPriceDisplay: formik.values.priceDisplay,
            }}
          />
        </div>
      </div>

      <div className="flex gap-5 mb-4">
        <HUButton
          text={word("global.previous")}
          onClick={() => setPageNumber((prev) => prev - 1)}
          type="Rounded"
          size="M"
          colorType="Quaternary"
          fullWidth
          icon={{
            iconView: <span className={`pi pi-arrow-left`} style={{ color: theme.mainWhite }} />,
          }}
        />
        <HUButton
          text={word("global.next")}
          onClick={handleSubmit}
          type="Right_Icon"
          size="M"
          colorType="Primary"
          fullWidth
          icon={{
            iconView: <span className={`pi pi-arrow-right`} style={{ color: theme.mainWhite }} />,
          }}
        />
      </div>
    </div>
  )
}
